import FilterSubmeta from "components/Category/FilterSubmeta"
import categoryStore from "stores/categoryStore"
import React from "react"
import {observer} from "mobx-react"

@observer
export default class FilterContainer extends React.Component {

	render() {
		const {category} = this.props
		let {hasFilter} = categoryStore
		let useFilter = hasFilter
		if ( !category ) return null
		let fields = false // category.meta.fields
		if ( !fields ) fields = category.meta.submeta.fields
		if ( !fields ) useFilter = false
		return <div className="FilterContainer">
			{useFilter && <div className="pv3">
				<FilterSubmeta
					query={this.props.query}
					useTranslate={true}
					title={"Filter"}
					category={category}
					fields={fields} />
			</div>}
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/theme/giraffiti/components/Filter/FilterContainer.js